<template>
  <CollapsePanel class="borrow-token-panel" name="borrow-token-panel">
    <div class="title" slot="title">借款</div>
    <div class="panel-content" slot="content">
      <Spin fix v-if="loading"></Spin>
      <div class="caption-title">
        预计借出后杠杆率：
        <div class="leverage-ratio" v-if="item.currentBorrowLeverage">
          <Progress
            :stroke-width="8"
            :stroke-color="progressBarColor"
            :percent="getLeverageRatio()"
            hide-info
          />
          <div class="cur-borrow-leverage" :style="{ color: progressBarColor }">
            {{ item.currentBorrowLeverage }}%
          </div>
          <div class="max-borrow-leverage">
            (max={{ item.maxBorrowLeverage }}%)
          </div>
        </div>
        <div v-else>-</div>
      </div>
      <div class="input-operate-container" v-if="!loading">
        <div class="input-and-ratio">
          <div class="input-group">
            <InputToken
              v-if="item.borrowTokenInfos"
              v-for="(borrowInfo, borrowInfoIndex) in item.borrowTokenInfos"
              :key="borrowInfo.symbol"
              :tokenSymbol="borrowInfo.symbol"
              v-model="item[`borrowTokenValue${borrowInfoIndex}`]"
              @on-change="function () {isChecked = false;}
              "
            />
          </div>
          <Slider
            v-model="slideRatio"
            :tip-format="format"
            @on-change="onSliderChange"
            :show-stops="false"
            :marks="{
              0: '0%',
              50: '50%',
              100: '100%',
            }"
          />
          <div
            class="info-container"
            v-if="item.borrowSlippageTitle && item.borrowSlippage"
          >
            {{ item.borrowSlippageTitle }}： {{ item.borrowSlippage || 0 }}%
          </div>
        </div>

        <div class="operate-wrapper">
          <Button
            type="success"
            @click="onCheck"
            :disabled="!item.borrowInfo || isChecked"
            >Check</Button
          >
          <Button
            type="primary"
            @click="onBorrow"
            :disabled="isBorrowButtonDisabled()"
            >Borrow</Button
          >
        </div>
      </div>

      <div v-show="false">{{ refreshCount }}</div>
    </div>
  </CollapsePanel>
</template>

<script>
import CollapsePanel from "../../../components/common/CollapsePanel";
import InputToken from "../../../components/common/InputToken";
import debounce from "lodash/debounce";

export default {
  name: "BorrowTokenPanel",
  props: {
    item: {
      type: Object,
    },
    refreshCount: Number,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CollapsePanel,
    InputToken,
  },
  mounted() {},
  data() {
    return {
      slideRatio: 0,
      progressBarColor: "#1BBE6B",
      isChecked: false,
    };
  },
  computed: {},
  methods: {
    format(val) {
      return val + "%";
    },
    onSliderChange: debounce(function (value) {
      if (!value) {
        this.$emit("on-reset");
        this.isChecked = true;
        return;
      }

      this.item.borrowTokenRatio = value;
      this.isChecked = false;
      this.$emit("cal-borrow");
    }, 500),
    onCheck: function () {
      this.slideRatio = 0;
      this.isChecked = true;
      this.$emit("on-check");
    },
    onBorrow: function () {
      this.$emit("on-borrow");
    },
    getLeverageRatio() {
      if (this.item.currentBorrowLeverage > this.item.maxBorrowLeverage) {
        this.progressBarColor = "#F72E54";
        return 100;
      } else {
        this.progressBarColor = "#1BBE6B";
        return (
          (this.item.currentBorrowLeverage / this.item.maxBorrowLeverage) * 100
        );
      }
    },
    isBorrowButtonDisabled() {
      if (!this.isChecked) return true;
      return (
        !this.item.currentBorrowLeverage ||
        !this.item.maxBorrowLeverage ||
        this.item.currentBorrowLeverage > this.item.maxBorrowLeverage
      );
    },
  },
  watch: {
    refreshCount: function (newValue) {},
    loading: function (newValue) {
      if (newValue) {
        this.slideRatio = 0;
        this.isChecked = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../common/fonts.scss";
@import "../../../common/colors.scss";

.flex-row {
  display: flex;
}

.title {
  @include fontSize-16;
  @include mediumFont;
  color: #e6e6e6;
}

.panel-content {
  background: #202125;
  border-radius: 16px;
  padding: 20px 16px;
  position: relative;
  overflow: hidden;

  .input-and-ratio {
    min-width: 60%;
  }

  .input-operate-container {
    display: flex;
  }

  .input-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(1, auto);
    grid-column-gap: 16px;
  }

  .operate-wrapper {
    display: grid;
    grid-template-columns: repeat(2, auto);
    grid-template-rows: repeat(1, auto);
    grid-column-gap: 16px;
    margin: 0 0 0 16px;

    button {
      margin: 3px 0 0 0;
    }
  }
}

.caption-title {
  @include fontSize-14;
  @include mediumFont;
  color: #fff;
  display: flex;
  align-items: center;
  margin: 0 0 20px 0;
}

.info-container {
  margin: 36px 0 0 0;
  background: rgba(#ff7b02, 0.05);
  border-radius: 16px;
  padding: 6px 16px;

  @include fontSize-12;
  @include regularFont;
  color: #ff7b02;
}

.leverage-ratio {
  min-width: 365px;
  width: 30%;
  display: flex;
  align-items: center;
  margin: 0 0 0 8px;

  .cur-borrow-leverage {
    @include fontSize-14;
    @include boldFont;
    color: #1bbe6b;
    margin: 0 0 0 10px;
  }

  .max-borrow-leverage {
    @include fontSize-12;
    @include mediumFont;
    color: #53545c;
    margin: 0 0 0 8px;
  }
}
</style>
